exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.admin-toolbar > .btn {\r\n  width: 30px;\r\n  padding: 5px !important;\r\n  text-align: center;\n}\r\n", ""]);

// exports
